import { ApiBaseService, ApiV2Service } from './api.base.service';
import store from '@/store/store';
import { GatewayTask, SuccessResponse } from '../types';

export class GatewayTaskService {
  private apiV2: ApiBaseService;

  constructor() {
    this.apiV2 = ApiV2Service;
  }

  public async getTasksByPositionId(positionId: number): Promise<{ gatewayTasks: GatewayTask[]; count: number }> {
    const organisation = store.getters.activeOrganisation[0].id;
    return this.apiV2.get(`organisation/${organisation}/gateways/tasks/positions/${positionId}`);
  }

  public async createTask(details: any): Promise<GatewayTask[]> {
    const organisation = store.getters.activeOrganisation[0].id;
    return this.apiV2.post(`organisation/${organisation}/gateways/tasks`, details);
  }

  public async updateTasks(ids: number[], tasks: Array<Partial<GatewayTask>>): Promise<GatewayTask[]> {
    const organisation = store.getters.activeOrganisation[0].id;
    return this.apiV2.put(`organisation/${organisation}/gateways/tasks`, { taskIds: ids, tasks });
  }

  public async setGatewayPositionNotes(positionId: number, notes: string = ''): Promise<SuccessResponse> {
    const organisation = store.getters.activeOrganisation[0].id;
    return this.apiV2.put(`organisation/${organisation}/gateways/positions/notes`, { positionId, notes });
  }

}

export default new GatewayTaskService();
